import Variables from '../variables';
import moment from 'moment';

export default function DateTimeComponent(datetimeStr, type, customDateFormat, customTimeFormat) {
    if (!datetimeStr) return '-';
    
    const dateFormat = customDateFormat || Variables.dateFormat;
    const timeFormat = customTimeFormat || Variables.timeFormat;

    const parsedMoment = moment(datetimeStr);
    if (!parsedMoment.isValid()) return datetimeStr;

    if (type === 'date') {
        return parsedMoment.format(dateFormat);
    } else if (type === 'time') {
        return parsedMoment.format(timeFormat);
    } else {
        return parsedMoment.format(`${dateFormat} ${timeFormat}`);
    }
}
